// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__1dGzN","ranges":"BmiRanges_ranges__3chU7"};